import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { rootReducer } from "../reducers/index";

const middleware = [thunk as any];

export const store = createStore(
  rootReducer as any,
  compose(applyMiddleware(...middleware))
);
